<template>
  <v-card>
    <v-card-text>
      <v-layout>
        <v-flex>
          <piechart :chart-data="chartdata" :options="chartoptions" style="height: 150px; width: 150px;"></piechart>
        </v-flex>
        <v-flex>
          <div style="height: 150px; overflow-y: auto; overflow-x: hidden;" class="ma-0">
            <div v-for="dev in devices">
              <v-layout align-center>
                <v-flex xs5 class="mr-2">
                  {{ dev }}
                </v-flex>
                <v-flex xs7>
                  <v-icon small>{{ getStatusIcon(devstates[dev]) }}</v-icon>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <div class="mt-3 ml-2 grey--text">
        <p class="title">Device states</p>
        <p class="body-1 mb-0">Total devices: <span class="green--text">{{ totalDevices }}</span></p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import PieChart from './piechart'
import mx_devstate from '../js/mixins'

export default {
  name: 'dash_devstate',
  mixins: [
    mx_devstate
  ],
  props: {
    devstates: {
      type: Object,
      required: true
    }
  },
  components: {
    piechart: PieChart
  },
  data: () => ({
    chartdata: null,
    chartoptions: {
      legend: {
        display: false,
        position: 'right'
      },
      maintainAspectRatio: false,
      responsive: true
    },
    desc_map: {
      'UNKNOWN': { 'description': 'Unknown' },
      'NOT_INUSE': { 'description': 'Available', 'bgcolor': '#AEEA00' },
      'INUSE': { 'description': 'In use', 'bgcolor': '#FF9100' },
      'BUSY': { 'description': 'Busy', 'bgcolor': '#6D4C41' },
      'INVALID': { 'description': 'Invalid' },
      'UNAVAILABLE': { 'description': 'Unavailable' },
      'RINGING': { 'description': 'Ringing', 'bgcolor': '#FF1744' },
      'RINGINUSE': { 'description': 'Ring in use' },
      'ONHOLD': { 'description': 'On hold' }
    }
  }),
  methods: {
    setData: function () {
      let grouping = {}
      Object.keys(this.devstates).forEach(function (k) {
        if (!(this.devstates[k] in grouping)) {
          grouping[this.devstates[k]] = 0
        }
        grouping[this.devstates[k]]++
      },this)

      let new_labels = []
      let new_data = []
      let bgcolor = []
      Object.keys(this.desc_map).forEach(function (k) {
        new_labels.push(this.desc_map[k].description)
        new_data.push(grouping[k] || 0)
        bgcolor.push(this.desc_map[k].bgcolor)
      },this)

      this.chartdata = {
        labels: new_labels,
        datasets: [
          {
            label: 'States',
            data: new_data,
            backgroundColor: bgcolor.slice()
          }
        ]
      }
    }
  },
  computed: {
    totalDevices: function () {
      return Object.keys(this.devstates).length
    },
    devices: function () {
      return Object.keys(this.devstates)
    }
  },
  watch: {
    devstates: function () {
      this.setData()
    }
  },
  beforeMount: function () {
    this.setData()
  }
}
</script>

<style scoped>
</style>
